// Bootstrap, Custom CSS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "./styles/main.css";

document.addEventListener("DOMContentLoaded", () => {
  const { controller, action } = document.body.dataset;

  // ==========================================================
  // 共通：フォーム二重送信防止
  // ==========================================================
  document.querySelectorAll("form").forEach((form) => {
    form.addEventListener("submit", () => {
      form
        .querySelectorAll("button, input[type='submit']")
        .forEach((element) => {
          element.disabled = true;
        });
    });
  });

  // questionnaires 以外では以下を実行しない
  if (controller !== "questionnaires") return;
  if (!["new", "back", "confirm"].includes(action)) return;

  const MAX_FACTORY_COUNT = 5;
  const CANNOT_ANSWER_VALUE = "1";
  const CANNOT_ANSWER_TEXT = "can not answer";

  const factoryCountSelect = document.querySelector(
    '[name="questionnaire[question_select_14]"]'
  );

  if (!factoryCountSelect) return;

  // ==========================================================
  // 共通処理
  // ==========================================================

  // question_select_14:
  // 1〜5 = 選択された件数
  // 6    = それ以上（画面上は5件として扱う）
  const selectedFactoryCount = () => {
    const value = Number.parseInt(factoryCountSelect.value, 10) || 0;

    return Math.min(value, MAX_FACTORY_COUNT);
  };

  const questionnaireField = (name) => {
    return document.querySelector(`[name="questionnaire[${name}]"]`);
  };

  const clearInput = (input) => {
    if (input.matches("input[type='radio'], input[type='checkbox']")) {
      input.checked = false;
    } else if (input.matches("select")) {
      input.selectedIndex = 0;
    } else {
      input.value = "";
    }

    input.required = false;
    input.readOnly = false;
  };

  const toggleDisabledStyle = (element, disabled) => {
    element.classList.toggle("opacity-50", disabled);
    element.classList.toggle("bg-light", disabled);
  };

  // ==========================================================
  // 1. 代替工場欄
  //
  // 対象行が有効、かつ question_select_17_X が「あり(1)」
  // の場合だけ入力可能・必須
  // ==========================================================
  // ==========================================================
  // 1. 代替工場欄
  //
  // 対象行が有効、かつ question_select_17_X が「あり(1)」
  // の場合だけ入力可能・必須
  //
  // 「なし」へ変更した場合は、代替工場欄の値を初期化する
  // ==========================================================
  const initRadioDependentBlocks = () => {
    const radioGroups = {};

    document
      .querySelectorAll(
        "input[type='radio'][name^='questionnaire[question_select_17_']"
      )
      .forEach((radio) => {
        const index = radio.dataset.index;
        if (!index) return;

        radioGroups[index] ||= [];
        radioGroups[index].push(radio);
      });

    const clearAlternativeFactoryFields = (block) => {
      block.querySelectorAll("input, select, textarea").forEach((input) => {
        if (input.matches("input[type='radio'], input[type='checkbox']")) {
          input.checked = false;
        } else if (input.matches("select")) {
          input.selectedIndex = 0;
        } else {
          input.value = "";
        }

        input.required = false;
        input.readOnly = false;
      });
    };

    const toggleBlock = (index, radios, clearWhenDisabled = false) => {
      const block = document.querySelector(
        `.dependent-block[data-index="${index}"]`
      );

      if (!block) return;

      const numericIndex = Number.parseInt(index, 10);
      const factoryRowEnabled =
        numericIndex <= selectedFactoryCount();

      const alternativeFactorySelected =
        radios.find((radio) => radio.checked)?.value === "1";

      const enabled =
        factoryRowEnabled && alternativeFactorySelected;

      if (!enabled && clearWhenDisabled) {
        clearAlternativeFactoryFields(block);
      }

      toggleDisabledStyle(block, !enabled);

      block.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = !enabled;
        input.required = enabled;
      });
    };

    const toggleAllBlocks = () => {
      Object.entries(radioGroups).forEach(([index, radios]) => {
        toggleBlock(index, radios);
      });
    };

    Object.entries(radioGroups).forEach(([index, radios]) => {
      radios.forEach((radio) => {
        radio.addEventListener("change", () => {
          // 利用者が「あり／なし」を変更したときは、
          // 無効化される代替工場欄を初期化する
          toggleBlock(index, radios, true);
        });
      });
    });

    // 初期表示時は、確認画面から戻った値を維持する
    toggleAllBlocks();

    return toggleAllBlocks;
  };

  // ==========================================================
  // 2. 製造拠点数に応じた工場行の入力可否
  //
  // question_select_14 で選択された件数まで入力可能・必須
  // 選択数を超える行は表示したまま入力不可・値を初期化
  // ==========================================================
  const initFactoryRowsToggle = (toggleAlternativeBlocks) => {
    const toggleRows = () => {
      const factoryCount = selectedFactoryCount();

      for (let index = 1; index <= MAX_FACTORY_COUNT; index += 1) {
        const row = document.querySelector(
          `.factory-row[data-index="${index}"]`
        );

        if (!row) continue;

        const enabled = index <= factoryCount;

        toggleDisabledStyle(row, !enabled);

        row.querySelectorAll("input, select, textarea").forEach((input) => {
          input.disabled = !enabled;

          const requiredFactoryFields = [
            `questionnaire[question_select_15_${index}]`,
            `questionnaire[question_zipcode_15_${index}]`,
            `questionnaire[question_text_15_${index}]`,
            `questionnaire[question_select_17_${index}]`
          ];

          if (requiredFactoryFields.includes(input.name)) {
            input.required = enabled;
          }

          if (!enabled) {
            clearInput(input);
          }
        });
      }

      toggleAlternativeBlocks?.();
    };

    factoryCountSelect.addEventListener("change", toggleRows);
    toggleRows();
  };

  // ==========================================================
  // 3. 製造拠点数に応じた質問25の入力可否
  //
  // question_select_14 が2以上なら入力可能・必須
  // 1以下または未選択なら表示したまま入力不可・値を初期化
  // ==========================================================
  const initFactoryQuestionToggle = () => {
    const block = document.getElementById("question-25-block");
    if (!block) return;

    const radios = block.querySelectorAll("input[type='radio']");

    const toggleEnabled = () => {
      const enabled = selectedFactoryCount() >= 2;

      block.style.display = "";
      toggleDisabledStyle(block, !enabled);

      radios.forEach((radio) => {
        radio.disabled = !enabled;
        radio.required = enabled;

        if (!enabled) {
          radio.checked = false;
        }
      });
    };

    factoryCountSelect.addEventListener("change", toggleEnabled);
    toggleEnabled();
  };

  // ==========================================================
  // 4. 工場・代替工場の「can not answer」制御
  //
  // 国の value が "1" の場合、
  // 対応する郵便番号・住所へ「can not answer」を自動入力
  // ==========================================================
  const initFactoryCannotAnswer = () => {
    const fieldGroups = [
      {
        selectPrefix: "question_select_15",
        zipcodePrefix: "question_zipcode_15",
        addressPrefix: "question_text_15"
      },
      {
        selectPrefix: "question_select_30",
        zipcodePrefix: "question_zipcode_30",
        addressPrefix: "question_text_30"
      }
    ];

    fieldGroups.forEach(
      ({ selectPrefix, zipcodePrefix, addressPrefix }) => {
        for (let index = 1; index <= MAX_FACTORY_COUNT; index += 1) {
          const countrySelect = questionnaireField(
            `${selectPrefix}_${index}`
          );
          const zipcodeInput = questionnaireField(
            `${zipcodePrefix}_${index}`
          );
          const addressInput = questionnaireField(
            `${addressPrefix}_${index}`
          );

          if (!countrySelect || !zipcodeInput || !addressInput) continue;

          const toggleCannotAnswer = () => {
            const cannotAnswerSelected =
              countrySelect.value === CANNOT_ANSWER_VALUE;

            if (cannotAnswerSelected) {
              zipcodeInput.value = CANNOT_ANSWER_TEXT;
              addressInput.value = CANNOT_ANSWER_TEXT;
            } else {
              if (zipcodeInput.value === CANNOT_ANSWER_TEXT) {
                zipcodeInput.value = "";
              }

              if (addressInput.value === CANNOT_ANSWER_TEXT) {
                addressInput.value = "";
              }
            }

            zipcodeInput.readOnly = cannotAnswerSelected;
            addressInput.readOnly = cannotAnswerSelected;
          };

          countrySelect.addEventListener("change", toggleCannotAnswer);
          toggleCannotAnswer();
        }
      }
    );
  };

  // ==========================================================
  // 初期化
  // ==========================================================
  const toggleAlternativeBlocks = initRadioDependentBlocks();

  initFactoryRowsToggle(toggleAlternativeBlocks);
  initFactoryQuestionToggle();
  initFactoryCannotAnswer();
});
